import styled from 'styled-components';

import { ctrlBase, fieldContainer, fieldLabel, fieldMessage } from '../base';

export const inputContainer = styled.div`
  ${fieldContainer}

  .ant-picker {
    background: none;
    border: none;
    box-shadow: none !important;
    padding: 0;
    width: 100%;
  }

  .ant-picker-suffix {
    display: none;
  }

  .ant-picker-clear {
    right: var(--s3) !important;
    background: var(--surface);
    color: var(--text-faint);
  }

  .ant-picker-input {
    position: relative;
    width: 100%;

    input {
      ${ctrlBase}
      text-align: left;
    }
  }
`;

export const input = styled.input`
  ${ctrlBase}
`;

export const label = styled.label`
  ${fieldLabel}
`;

export const message = styled.span`
  ${fieldMessage}
`;

export const icon = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: var(--s3);
  display: flex;
  align-items: center;
  color: var(--text-faint);
  z-index: 9;
`;

export const InputBox = styled.div`
  position: relative;
`;
